import React, { useEffect, useMemo, useState } from 'react'
import { motion } from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/member.css'
import xm1 from '../assets/images/aboutmain.png'
import eli from '../assets/images/eli.png'
import elib from '../assets/images/elib.png'
import check from '../assets/images/check.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'

/* ===== Pricing Section Helpers (inline) ===== */
const PsCheck = () => (
  <span className="ps__check" aria-hidden="true">
    <svg viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="9" fill="currentColor" opacity="0.16" />
      <path
        d="M6.2 10.3l2.2 2.3 5.4-5.6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const PlanIcon = ({ variant }) => {
  if (variant === "basic") {
    return (
      <span className="ps__planIcon ps__planIcon--basic" aria-hidden="true">
        <svg viewBox="0 0 44 44" fill="none">
          <rect x="6" y="6" width="32" height="32" rx="10" fill="currentColor" opacity="0.12" />
          <path d="M22 12v20" stroke="currentColor" strokeWidth="5" strokeLinecap="round" opacity="0.7" />
          <path d="M22 12a10 10 0 0 0 0 20" fill="currentColor" opacity="0.45" />
        </svg>
      </span>
    );
  }

  if (variant === "pro") {
    return (
      <span className="ps__planIcon ps__planIcon--pro" aria-hidden="true">
        <svg viewBox="0 0 44 44" fill="none">
          <rect x="6" y="6" width="32" height="32" rx="10" fill="currentColor" opacity="0.12" />
          <rect x="16" y="13" width="6" height="18" rx="2" fill="currentColor" opacity="0.55" />
          <rect x="23" y="13" width="6" height="18" rx="2" fill="currentColor" opacity="0.85" />
        </svg>
      </span>
    );
  }

  return (
    <span className="ps__planIcon ps__planIcon--ent" aria-hidden="true">
      <svg viewBox="0 0 44 44" fill="none">
        <rect x="6" y="6" width="32" height="32" rx="10" fill="currentColor" opacity="0.12" />
        <path d="M22 12l10 7-10 7-10-7 10-7z" fill="currentColor" opacity="0.75" />
        <path d="M12 19l10 7 10-7" stroke="currentColor" strokeWidth="2" opacity="0.5" />
      </svg>
    </span>
  );
};

const Toggle = ({ yearly, onChange }) => (
  <div className="ps__toggle" role="group" aria-label="Billing period">
    <span className={`ps__toggleLabel ${!yearly ? "is-active" : ""}`}>Monthly</span>

    <button
      type="button"
      className={`ps__switch ${yearly ? "is-on" : ""}`}
      onClick={onChange}
      aria-pressed={yearly}
      aria-label="Toggle annual billing"
    >
      <span className="ps__knob" />
    </button>

    <span className={`ps__toggleLabel ${yearly ? "is-active" : ""}`}>Annually</span>
  </div>
);

const PlanCard = ({ plan, yearly }) => {
  const price = yearly ? plan.priceYear : plan.priceMonth;
  const per = yearly ? "/year" : "/monthly";

  return (
    <article className={`psCard ${plan.featured ? "psCard--featured" : ""}`}>
      {plan.featured && <div className="psCard__badge">Popular</div>}

      <div className="psCard__top">
        <PlanIcon variant={plan.variant} />
        <div className="psCard__meta">
          <div className="psCard__for">{plan.for}</div>
          <div className="psCard__name">{plan.name}</div>
        </div>
      </div>

      <p className="psCard__desc">{plan.desc}</p>

      <div className="psCard__priceRow">
        <span className="psCard__price">${price}</span>
        <span className="psCard__per">{per}</span>
      </div>

      <div className="psCard__included">What’s included</div>

      <ul className="psCard__list">
        {plan.features.map((f, i) => (
          <li key={i} className="psCard__li">
            <PsCheck />
            {f}
          </li>
        ))}
      </ul>

      <button className="psCard__btn" type="button">
        Get started
      </button>
    </article>
  );
};

const Member = () => {
  const [yearly, setYearly] = useState(false);

  useEffect(() => {
    AOS.init();
  }, []);

  const plans = useMemo(
    () => [
      {
        variant: "basic",
        for: "For individuals",
        name: "Basic",
        desc: "Lorem ipsum dolor sit amet doloroli sitiol consectetur adipiscing elit.",
        priceMonth: 99,
        priceYear: 999,
        features: [
          "All analytics features",
          "Up to 250,000 tracked visits",
          "Normal support",
          "Up to 3 team members",
        ],
      },
      {
        variant: "pro",
        for: "For startups",
        name: "Pro",
        desc: "Lorem ipsum dolor sit amet doloroli sitiol consectetur adipiscing elit.",
        priceMonth: 199,
        priceYear: 1999,
        featured: true,
        features: [
          "All analytics features",
          "Up to 1,000,000 tracked visits",
          "Premium support",
          "Up to 10 team members",
        ],
      },
      {
        variant: "enterprise",
        for: "For big companies",
        name: "Enterprise",
        desc: "Lorem ipsum dolor sit amet doloroli sitiol consectetur adipiscing elit.",
        priceMonth: 399,
        priceYear: 3999,
        features: [
          "All analytics features",
          "Up to 5,000,000 tracked visits",
          "Dedicated support",
          "Up to 50 team members",
        ],
      },
    ],
    []
  );

  return (
    <div>

      {/* ✅ Your Hero Section */}
      <section className='main_sec'>
        <div className='x_row1'>
          <div className='x_col'>
            <h1 style={{lineHeight:"60px"}} data-aos="fade-right">
              Membership <br />
              & Pricing
            </h1>

            <p data-aos="fade-right">
              Elevate your work experience with our diverse range of membership options tailored to suit your professional needs.
              At Xceed Office, we are dedicated to providing a vibrant and conducive workspace that fosters productivity and innovation.
            </p>
          </div>

          <div className='x_col'>
            <img src={xm1} alt="" />
          </div>
        </div>
      </section>

      <br /><br /><br /><br />

      {/* ✅ Simple, transparent pricing section (ADDED) */}
      <section className="ps">
        <div className="ps__wrap">
          <div className="ps__kicker">PRICING</div>

          <h2 className="ps__title">Simple, transparent pricing</h2>

          <p className="ps__sub">
            Lorem ipsum dolor sit amet consectetur adipisicing elit dolor posuere
            vel venenatis eu sit massa volutpat.
          </p>

          <Toggle yearly={yearly} onChange={() => setYearly(v => !v)} />

          <div className="ps__grid">
            {plans.map((p) => (
              <PlanCard key={p.name} plan={p} yearly={yearly} />
            ))}
          </div>
        </div>
      </section>

    </div>
  )
}

export default Member